import React, { useEffect, useState } from "react";
import BlogListing from "../components/common/blogListing";
import Pagination from "../components/common/pagination";
import { navigate } from "gatsby";
import TaxonomySidebarFilter from "../components/common/TaxonomySidebarFilter";
import { useLocation } from "@reach/router";
import axios from "axios";
import { Circles } from "react-loader-spinner";

const useQuery = (queryParam) => {
  const search = new URLSearchParams(useLocation().search);
  return search.get(queryParam);
};

const Category = ({ pageContext }) => {
  const { category } = pageContext;
  const pageno = useQuery("page");

  const [listing, setListing] = useState([]);
  const [meta, setMeta] = useState({});
  const [loading, setLoading] = useState(true);

  const page = pageno ?? 1;

  async function getCategories(slug) {
    const apiUrl = `https://api.catcomnet.com/contents?filters[taxonomy][slug]=${slug}&page=${page}&per_page=50&sort_order=desc&sort_by=created_at`;
    const authToken = process.env.GATSBY_AUTH_TOKEN;

    const data = await axios.get(apiUrl, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    });
    setListing(data.data?.data);
    setMeta(data.data.meta);
    setLoading(false);
  }

  useEffect(() => {
    getCategories(category.slug);
  }, []);

  function handleNext() {
    navigate(`/category/${category.slug}?page=${page + 1}`);
  }

  function handlePrev() {
    navigate(`/category/${category.slug}?page=${page - 1}`);
  }

  console.log(category);
  return (
    <div className="blogspage container">
      <div className="left pt-[40px] md:pt-[80px]">
        <div className="px-4">
          <h1 className="text-white tracking-wider font-bold">
            {category.name}
          </h1>
          {category.description && (
            <div
              className="md:text-lg text-white/80 tracking-wide"
              dangerouslySetInnerHTML={{
                __html: category.description,
              }}
            />
          )}
        </div>
        {!!listing.length && <BlogListing data={listing} />}

        {loading && (
          <div className="px-10">
            <Circles
              height="80"
              width="80"
              color="#ffffff"
              ariaLabel="circles-loading"
              wrapperStyle={{}}
              wrapperClass=""
              visible={true}
            />
          </div>
        )}
        {!!listing.length && meta && (
          <Pagination
            startingIndex={meta.from}
            endingIndex={meta.to}
            totalPages={meta.total}
            previousEnabled={meta.current_page > 1}
            nextEnabled={meta.current_page < meta.last_page}
            handleNext={handleNext}
            handlePrev={handlePrev}
          />
        )}
      </div>
      <div className="right">
        <TaxonomySidebarFilter
          contentType="category"
          iframeIds={[
            "99ab7f39-3b4f-498f-87de-a15521c03bcf",
            "99ab7ffd-898f-438a-82da-1e9d8bc98ef7",
          ]}
        />
      </div>
    </div>
  );
};

// export function Head({ location, data }) {
//   const metaTag = data.sanityTag.pageMetadata;
//   const pageData = data.sanityTag;
//   const seoData = {
//     title: metaTag?.title || pageData.name,
//     description: metaTag?.description,
//     image: metaTag?.image,
//     keywords: metaTag?.keywords,
//     schema: metaTag?.schema,
//   };

//   return <Seo location={location} data={seoData} />;
// }

export default Category;
